import React from "react";
import { useParams } from "react-router-dom";
import { investidores } from "./investors";
import { Link } from 'react-router-dom';

// Dicionário de frases personalizadas
const frasesInvestidores = {
  Ewerton: "Olá Ewerton! Que bom ter você aqui. Gravei este vídeo rápido para explicar o racional do projeto. Assista com atenção e depois siga para a página com mais detalhes.",
  rafa: "Olá Rafa! Fico feliz em ter você por aqui. Veja este vídeo curto que preparei especialmente para você.",
  andreia: "Olá Andreia! Que bom que você chegou até aqui. Assista este vídeo com atenção e depois veja mais detalhes.",
  luciana: "Olá Luciana! Preparei este vídeo exclusivo para você entender melhor a proposta da IMO Investimentos.",
  geral1: "Olá! Que bom ter você aqui. Veja este vídeo com atenção e conheça mais sobre as oportunidades que estou apresentando.",
  geral2: "Bem-vindo! Assista este vídeo rápido para entender o racional do projeto que estou desenvolvendo.",
  Marino: "ola o la"
};

const InvestorPage = () => {
  const { nomeInvestidor } = useParams();
  const videoUrl = investidores[nomeInvestidor];

  return (
    <div
      style={{
        backgroundColor: "#fff",
        height: "100vh", // altura fixa
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      {/* Logo da IMO */}
      <img
        src="Logotipo1.jpg"
        alt="IMO Investimentos"
        style={{
          maxWidth: "250px",
          height: "auto",
          marginTop: "10px",
        }}
      />

      {/* Frase personalizada */}
      <p
        style={{
          fontSize: "18px",
          marginTop: "20px",
          marginBottom: "10px",
          textAlign: "center",
          color: "#000",
          maxWidth: "800px",
        }}
      >
        {frasesInvestidores[nomeInvestidor] || ""}
      </p>

      {videoUrl ? (
        <>
          {/* Video com altura controlada */}
          <div
            style={{
              width: "100%",
              maxWidth: "960px",
              flex: "1 1 auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                paddingTop: "56.25%", // 16:9 ratio
                borderRadius: "16px", // borda arredondada → aqui você coloca o valor desejado
                overflow: "hidden", // importante para cortar o iframe no border-radius
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)", // opcional → sombra bonita
              }}
            >
              <iframe
                src={videoUrl}
                title={`Vídeo de ${nomeInvestidor}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
              ></iframe>
            </div>
          </div>

          {/* Frase + Botão */}
          <div className="text-center mb-3">
            <div className="d-flex justify-content-center align-items-center">
              <Link to="/" style={{ textDecoration: 'none' }}>
                <button
                  className="btn border-0 mb-3 px-5 py-3 fw-bold"
                  style={{
                    backgroundColor: "#ECA600",
                    letterSpacing: "1.8px",
                    borderRadius: "50px",
                    fontSize: "1.1rem",
                    color: "black",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#f0b000";
                    e.target.style.color = "#fff";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#ECA600";
                    e.target.style.color = "black";
                  }}
                >
                  CLIQUE AQUI PARA IR PARA A PÁGINA DA IMO INVESTIMENTOS
                </button>
              </Link>
            </div>
          </div>
        </>
      ) : (
        <p
          style={{
            fontSize: "18px",
            marginTop: "20px",
            color: "#000",
          }}
        >
          Investidor não encontrado.
        </p>
      )}
    </div>
  );
};

export default InvestorPage;

